import App from './App';
import './style.css';
export default function IntegratedInstagramApp() { return <div className="agent-shell-instagram"><App /></div>; }
